import { Col, Row } from "antd"
import { useEffect, useState } from "react"
import TitleCustom from "src/components/TitleCustom"
import { GUIDE_EMPTY } from "src/constants/constants"
import { removeDiacritics } from "src/lib/stringsUtils"
import AssociationService from "src/services/AssociationService"
import AssociationForm from "./components/AssociationForm"
import { AssociationStyle } from "./styled"

const AssociationRegistration = () => {
  const [loading, setLoading] = useState(false)
  const [treeData, setTreeData] = useState([])

  const nest = (items, id, link) => {
    return items
      ?.filter(item => item[link] === id)
      .map(item => ({
        ...item,
        title: item.title,
        key: item.key,
        value: item.key,
        children: nest(items, item?.key, link),
      }))
  }

  const sort = data => {
    return data?.sort((a, b) => {
      if (a.SortOrder !== b.SortOrder) {
        return a.SortOrder - b.SortOrder
      }
      return a.removeDiacriticsTitle?.localeCompare(b.removeDiacriticsTitle)
    })
  }

  const getListAssoc = async () => {
    try {
      setLoading(true)
      const res = await AssociationService.getAssociationListNoAuthor({
        AssociationID: GUIDE_EMPTY,
        AssociationName: "",
        Status: 3,
      })
      if (res?.isError) return

      const dataList = sort(
        res?.Object?.map(item => ({
          ...item,
          key: item?.AssociationID,
          title: item?.AssociationName || "",
          removeDiacriticsTitle: removeDiacritics(
            item?.AssociationName.toLowerCase(),
          ),
        })),
      )

      const tree = nest(sort(dataList), GUIDE_EMPTY, "ParentID")
      setTreeData({ tree: tree, dataList: dataList })
    } finally {
      setLoading(false)
    }
  }

  const handleRefreshData = () => {
    getListAssoc()
  }

  useEffect(() => {
    getListAssoc()
  }, [])

  return (
    <AssociationStyle>
      <TitleCustom>Thêm mới hiệp hội</TitleCustom>
      <Row gutter={[16, 16]}>
        <Col style={{ width: 0 }} flex="auto">
          <div className="detail-box">
            <AssociationForm
              treeData={treeData}
              loading={loading}
              setLoading={setLoading}
              onSuccess={handleRefreshData}
            />
          </div>
        </Col>
      </Row>
    </AssociationStyle>
  )
}

export default AssociationRegistration
